import { useQuery } from '@tanstack/vue-query';
import { api } from '@/modules/services';
import { relate } from '@/utils/Relationships';

export const useStaffs = () => {
  return useQuery({
    queryKey: ['staffs', 'available'],
    queryFn: async () => {
        const { data: response } = await api.staff.all().then(relate([
            ['platform_id@id', 'platform'],
        ]));

        return response.data;
    },
    throwOnError: true,
  })
}
